import Head from "next/head";
import { FunctionComponent } from "react";

import { Tabpanel } from "@/components";

const Terms: FunctionComponent = () => (
  <>
    <Head>
      <title>BankX - Terms</title>
    </Head>
    <h2 className="column-3 column-span-9">
      BankX Terms and Conditions of Use
    </h2>
    <Tabpanel className="column-3 column-span-9" label="Terms">
      <p>
        Becoming part of the BankX community by procuring any amount of BankX,
        XSD tokens, NFT’s or locking up tokens in Token LockUp Rewards through
        any means (e.g. minting, trading, staking, purchasing etc…) or
        interacting with the BankX blockchain system of smart contracts or
        website, www.BankX.io, www.AIDeFi.io or any of its AI Agents (Delta V,
        etc.), “You” agree to the following terms and conditions.
      </p>
      <p>
        IF YOU DO NOT AGREE TO THESE TERMS, DO NOT PURCHASE, MINT, INTERACT,
        WITH OR OBTAIN THROUGH TRADE OR OTHER MEANS any tokens in the BankX
        system of smart contracts or use any website front end, specifically
        www.BankX.io, that will interact with the BankX system of smart
        contracts on the blockchain. BY PURCHASING, MINTING, INTERACTING WITH,
        OR OBTAINING THROUGH ANY MEANS ANY TOKEN IN THE BANKX SYSTEM OF
        BLOCKCHAIN SMART CONTRACTS, YOU WILL BE BOUND BY THESE TERMS AND ANY
        TERMS INCORPORATED BY REFERENCE HEREIN. IF YOU DO NOT FULLY UNDERSTAND
        THESE TERMS OR THOSE INCORPORATED BY REFERENCE HEREIN, DO NOT PURCHASE,
        MINT, INTERACT WITH, OR OBTAIN THROUGH TRADE OR OTHER MEANS any tokens
        in the BankX system of smart contracts, or use any website front end,
        specifically www.BankX.io, that will interact with the BankX system of
        smart contracts on the blockchain.
      </p>
      <p>
        You do not currently, nor will you in the future, have an(y)
        expectation(s) of profiting as a result of the actions or inactions of
        other individuals or entities.
      </p>
      <p>
        You acknowledge and accept that your involvement in the community does
        not create or establish a shared or common enterprise among or between
        community members. You do not currently, nor will you in the future have
        an(y) expectation of, or entitlement to, promotion(s), endorsement(s),
        acknowledgement(s), or other efforts by an(y) individual(s) or
        entity(ies) within or outside of the community relating to the community
        or BankX.
      </p>
      <p>
        You acknowledge that, as a prudent and responsible community member, you
        benefit greatly from having any code that you plan to execute reviewed
        by a competent coder or computer scientist.
      </p>
      <p>
        You acknowledge and accept that Blockchains, Smart Contracts,
        Cryptographic Currencies, and the like are rapidly evolving and
        relatively new technologies that are accompanied by inherent risk,
        however small, of total failure. In addition, distributed software
        operating on distributed computers is exponentially more complex and
        intricate than traditional software operating on a single or confined
        network(s). Despite the seemingly insurmountable notion of breaking or
        hacking cryptography, you acknowledge and accept that “breaking”
        cryptography would likely result in the destruction of all cryptographic
        tokens, coins, currencies, NFT’s and the like.
      </p>
      <p>
        The Howey Test, developed by the US Supreme Court in 1946, outlines the
        considerations used to determine whether a contract constitutes a
        security subject to registration with and regulation by the SEC.
      </p>
      <p>
        As it relates to you being part of the BankX community, you acknowledge
        and agree that there is no investment of money and nor a common
        enterprise.
      </p>
      <p>
        You acknowledge, accept, and agree that cryptocurrencies are extremely
        volatile and as such, significant declines in value can occur.
      </p>
      <h2>Website Terms and Conditions of Use</h2>
      <h2>1. Terms</h2>
      <p>
        By accessing this Website, accessible from&nbsp;www.BankX.io, you are
        agreeing to be bound by these Website Terms and Conditions of Use and
        agree that you, and you alone, are required to comply with any
        applicable state, local, or federal laws or regulations. If you disagree
        with any of these terms, you are prohibited from accessing this site or
        blockchain application. The materials contained in Website are protected
        by copyright and trademark law.
      </p>
      <h2>2. Use License</h2>
      <p>
        Permission is granted to temporarily download one copy of the materials
        on BankX’s Website for personal, non-commercial transitory viewing only.
        This is the grant of a license, not a transfer of title, and under this
        license you may not:
      </p>
      <ol>
        <li>
          Modify, publish, republish, distribute, disseminate, or copy the
          materials;
        </li>
        <li>
          Use the materials for any commercial purpose or for any public
          display;
        </li>
        <li>
          Attempt to reverse engineer any software contained on BankX’s Website;
        </li>
        <li>
          Remove any copyright or other proprietary notations from the
          materials; or
        </li>
        <li>
          Transfer the materials to another person or “mirror” the materials on
          any server or device.
        </li>
      </ol>
      <p>
        BankX retains and reserves the right to terminate upon violations of any
        of these restrictions. Upon termination, your viewing right will also be
        terminated and you agree to destroy any downloaded materials in your
        possession whether it is printed or electronic format.
      </p>
      <h2>3. Disclaimer</h2>
      <p>
        All the materials on BankX’s Website are provided “as is”. BankX makes
        no representations or warranties, expressed or implied, as to any matter
        whatsoever, including, without limitation warranties or representations
        with respect to the accuracy or reliability of the use of the materials
        on its Website or otherwise relating to such materials or any sites
        linked to this Website.
      </p>
      <h2>4. Limitations</h2>
      <p>
        Neither BankX nor its suppliers will be held accountable or otherwise
        liable for any damages, direct or indirect, that are caused or
        proximately caused by the use or inability to use the materials on
        BankX’s Website—including without limitation, if BankX or an authorized
        representative of this Website has been notified, orally or written, of
        the possibility of such damage. Notwithstanding the same, the
        aforementioned limitations may not apply in jurisdictions prohibiting
        limitations on implied warranties or limitations of liability for
        incidental damages.{" "}
      </p>
      <h2>5. Revisions and Errata</h2>
      <p>
        The materials appearing on BankX’s Website may include technical,
        typographical, or photographic errors. BankX will not promise that any
        of the materials in this Website are accurate, complete, or current.
        BankX may change the materials contained on its Website at any time and
        without notice. BankX does not make any commitment to update the
        materials.
      </p>
      <h2>6. Links</h2>
      <p>
        BankX has not reviewed all of the sites linked to its Website and is not
        responsible for the contents of any such linked site. Likewise, the
        presence of any link does not imply endorsement by BankX. The use of any
        linked website is at the user’s own risk.
      </p>
      <h2>7. Site Terms of Use Modifications</h2>
      <p>
        BankX may revise and amend these Terms of Use at any time with or
        without prior notice. By using this Website, you are agreeing to be
        bound by the current version of these Terms and Conditions of Use, as
        amended from time to time.
      </p>
      <h2>8. Privacy Policy for BankX</h2>
      <p>
        At&nbsp;www.BankX.io, accessible
        from&nbsp;https://BankX.io&nbsp;or&nbsp;http://BankX.io&nbsp;or any or
        any subdomain, a foundational tenant is the privacy of its visitors.
        This Privacy Policy document contains types of information that is
        collected and recorded by&nbsp;www.BankX.io&nbsp;and how we use it.
      </p>
      <p>
        <b>
          If you have additional questions or require more information about our
          Privacy Policy, do not hesitate to submit your questions or requests
          to other members of our community in one of our social media accounts.
        </b>
      </p>
      <h2>Analytics</h2>
      <p>
        If you truly care about your privacy, you should be using the tor
        browser from&nbsp;http://tor.eff.org. Doing so will drastically limit or
        completely eliminate the transmission of your unique user data. The
        BankX community views unique user data as a burden. That being said, the
        site uses google analytics and is hosted on Ionos at this time and could
        change in the future. The hosting companies provide this as a component
        of the hosting services’ analytics. The information collected by
        analytics includes internet protocol (IP) addresses, browser type,
        Internet Service Provider (ISP), date and time stamp, referring/exit
        pages, and possibly the number of clicks. These are not linked to any
        information that is personally identifiable. The purpose of the
        information is for analyzing trends, administering the site, tracking
        users’ movement on the website, and gathering demographic information.
        No matter what any company writes in their terms of service, they can
        always change them, or break their own rules, so you must be responsible
        for protecting your own privacy.
      </p>
      <h2>Cookies and Web Beacons</h2>
      <p>
        Like any other website,&nbsp;www.BankX.io&nbsp;uses ‘cookies’. These
        cookies are used to store information including visitors’ preferences,
        and the pages on the website that the visitor accessed or visited. The
        information is used to optimize the users’ experience by customizing the
        web page content based upon each visitor’s browser type and/or other
        information.
      </p>
      <h2>Privacy Policies</h2>
      <p>
        Third-party ad servers or ad networks use technologies such as cookies,
        JavaScript, or Web Beacons in their respective advertisements and links
        appearing on&nbsp;www.BankX.io.&nbsp;Such advertisements are sent
        directly to each user’s browser. Through the sending of such
        advertisements directly to your browser, the ad servers or ad networks
        automatically receive your IP address. These technologies are used to
        measure the effectiveness of their advertising campaigns and/or to
        personalize the advertising content that you see on websites that you
        visit.
      </p>
      <p>
        Note that&nbsp;www.BankX.io&nbsp;has no access to or control over these
        cookies that are used by third-party advertisers.
      </p>
      <h2>Third Party Privacy Policies</h2>
      <p>
        www.BankX.io&nbsp;Privacy Policy does not apply to other advertisers or
        websites. Thus, you may wish to consult the respective Privacy Policies
        of any third-party ad servers for more detailed information. It may
        include their practices and instructions about how to opt-out of certain
        options.
      </p>
      <p>
        You may choose to disable cookies through your individual browser
        options. To know more detailed information about cookie management with
        specific web browsers, you may try the browsers’ respective websites.
      </p>
      <h2>Children’s Information</h2>
      <p>
        Another priority of this community is adding protection for children
        while using the internet. Parents and guardians are encouraged to
        observe, participate in, and/or monitor and guide children’s online
        activity.
      </p>
      <p>
        www.BankX.io&nbsp;does not knowingly collect any Personal Identifiable
        Information from children under the age of 13. If you think that your
        child provided this kind of information on the BankX website, you are
        strongly encouraged to utilize the reporting link here—as doing so
        ensures all measures are promptly taken to permanently remove any such
        information from all records
      </p>
      <h2>Online Privacy Policy Only</h2>
      <p>
        This Privacy Policy applies only to online activities and is valid for
        visitors to www.BankX.io with regards to the information that was shared
        and/or collect in&nbsp;www.BankX.io. This policy is not applicable to
        any information collected offline or via channels other than this
        website.
      </p>
      <h2>Consent</h2>
      <p>
        By using our website, you hereby consent to our Privacy Policy and agree
        to its Terms and Conditions.
      </p>
      <h2>9. Governing Law</h2>
      <p>
        Any dispute or claim arising from or related to the BankX’s Website
        shall be governed by the laws of the state of Texas, without regard to
        its conflict of law provisions.
      </p>
      <h2>1. LEGAL DISCLAIMER</h2>
      <p>
        Risks related to the use of BankX Website, Server and Blockchain
        Software, “User Chosen Software Assister” tool.
      </p>
      <p>
        BankX will not be responsible for any losses, damages or claims arising
        from events substantially falling within the scope of the following five
        categories:
      </p>
      <p>
        Errors, mistakes, or omissions made by the user of any
        cryptocurrency-related software or service. This includes, without
        limitation, forgotten or lost passwords, payments sent to wrong coin
        wallet addresses, and deletion, deactivation, or removal of BankX’s
        “User Chosen Software Assister” tool.
      </p>
      <p>
        Software problems of the BankX “User Chosen Software Assister” tool
        and/or any cryptocurrency-related software or service, to include,
        without limitation, corruption of the BankX “User Chosen Software
        Assister” file, incorrectly constructed transactions, unsafe or
        unsupported cryptographic libraries, malware or other incompatible
        programs affecting the BankX “User Chosen Software Assister” tool and/or
        any cryptocurrency-related software or service.
      </p>
      <p>
        Technical failures in the hardware of the user of any
        cryptocurrency-related software or service, (e.g., data loss due to a
        faulty or damaged storage device).
      </p>
      <p>
        Security problems experienced by the user of any cryptocurrency-related
        software or service, including, without limitation, unauthorized access
        to a user’s BankX “User Chosen Software Assister” tool and/or
        account(s).
      </p>
      <p>
        Actions or inactions of third parties and/or events experienced by third
        parties, including, without limitation, bankruptcy or disruption of
        service providers, information security attacks on service providers,
        and fraud committed by third parties.
      </p>
      <h2>2. Trading and Investment risks</h2>
      <p>
        There is considerable exposure to risk in any cryptocurrency exchange
        transaction. Any transaction involving cryptocurrencies involves risks
        including, but not limited to, the potential for changing economic
        conditions that may substantially affect the price or liquidity of a
        cryptocurrency. Investments in cryptocurrency exchange speculation may
        also be susceptible to sharp rises and falls as the relevant market
        values fluctuate. It is for this reason that when speculating in such
        markets it is advisable to use only risk capital.
      </p>
      <h2>3. Electronic Trading Risks</h2>
      <p>
        Before you engage in transactions using an electronic system, you should
        carefully review the rules and regulations of the exchanges offering the
        system and/or listing the instruments that you intend to trade. Online
        trading has inherent risk due to system response and access times that
        may vary based upon market conditions, system performance, and other
        factors. You should understand these and additional risks before
        trading.
      </p>
      <h2>4. Compliance with tax obligations</h2>
      <p>
        The users of the BankX “User Chosen Software Assister” tool are solely
        responsible to determinate what, if any, taxes apply to their
        cryptocurrency transactions. The owners of, or contributors to, the
        BankX “User Chosen Software Assister” are NOT responsible for
        determining the taxes that apply to cryptocurrency transactions.
      </p>
      <h2>5. No warranties</h2>
      <p>
        The BankX “User Chosen Software Assister” tool is provided on an “as is”
        basis, without any warranties of any kind regarding the BankX “User
        Chosen Software Assister” tool and/or any content, data, materials
        and/or services provided on the BankX “User Chosen Software Assister”
        tool.
      </p>
      <h2>6. Limitation of liability</h2>
      <p>
        To the greatest extent permitted by law, in no event shall the owners
        of, or contributors to, the BankX “User Chosen Software Assister” tool
        be liable for any damages of any kind, including, but not limited to,
        loss of use, lost profits, or data loss arising out of or in any way
        connected with the use of the BankX “User Chosen Software Assister”
        tool. In no way are the owners of, or contributors to, the BankX “User
        Chosen Software Assister” tool responsible for the actions, inactions,
        decisions, or other behavior taken or not taken by you in reliance upon
        the BankX “User Chosen Software Assister” tool.
      </p>
      <h2>
        AGREEING TO THE TERMS AND CONDITIONS OF THE USE OF BANKX CONSTITUTES A
        WAIVER OF YOUR RIGHT TO A TRIAL BY JURY AND PARTICIPATION IN A CLASS
        ACTION LAWSUIT.
      </h2>
      <h2>7. Arbitration</h2>
      <p>
        The user of the BankX “User Chosen Software Assister” tool agrees to
        arbitrate any dispute, including but not limited to claims for specific
        performance, arising from or in connection with the BankX “User Chosen
        Software Assister” tool or this disclaimer, except for disputes related
        to copyrights, logos, trademarks, trade names, trade secrets or patents.
        All aforementioned arbitrations shall be finally decided in AAA
        (Triple-A) Arbitration in the State of Texas. The user of the BankX
        “User Chosen Software Assister” tool further agrees and submits to
        jurisdiction in Texas.{" "}
      </p>
      <h2>8. Last amendment</h2>
      <p>This disclaimer was amended for the last time on March 3, 2023.</p>
      <h2>Privacy Policy for BankX</h2>
      <p>
        At&nbsp;www.BankX.io, accessible
        from&nbsp;https://BankX.io&nbsp;or&nbsp;http://BankX.io&nbsp;or any or
        any subdomain, one of our main priorities is the privacy of its
        visitors. This Privacy Policy document contains types of information
        that is collected and recorded by&nbsp;www.BankX.io&nbsp;and how we use
        it.
      </p>
      <p>
        <b>
          If you have additional questions or require more information about our
          Privacy Policy, do not hesitate to submit your questions or requests
          to other members of our community in one of our social media accounts.
        </b>
      </p>
      <h2>Analytics</h2>
      <p>
        If you really care about your privacy you should be using the tor
        browser from&nbsp;http://tor.eff.org. We prefer not to have any data
        about you at all really, as it is a liability. We do use google
        analytics and are hosted on Ionos currently to try and figure out where
        traffic is coming from and which pages on the site are being read the
        most. Many hosting companies do this and a part of hosting services’
        analytics. The information collected by analytics includes internet
        protocol (IP) addresses, browser type, Internet Service Provider (ISP),
        date and time stamp, referring/exit pages, and possibly the number of
        clicks. These are not linked to any information that is personally
        identifiable. The purpose of the information is for analyzing trends,
        administering the site, tracking users’ movement on the website, and
        gathering demographic information. No matter what any company writes in
        their terms of service, they can always change them, or break their own
        rules, so you must be responsible for protecting your own privacy.
      </p>
      <h2>Cookies and Web Beacons</h2>
      <p>
        Like any other website,&nbsp;www.BankX.io&nbsp;uses ‘cookies’. These
        cookies are used to store information including visitors’ preferences,
        and the pages on the website that the visitor accessed or visited. The
        information is used to optimize the users’ experience by customizing our
        web page content based on visitors’ browser type and/or other
        information.
      </p>
      <h2>Privacy Policies</h2>
      <p>
        Third-party ad servers or ad networks uses technologies like cookies,
        JavaScript, or Web Beacons that are used in their respective
        advertisements and links that appear on&nbsp;www.BankX.io&nbsp;which are
        sent directly to users’ browser. They automatically receive your IP
        address when this occurs. These technologies are used to measure the
        effectiveness of their advertising campaigns and/or to personalize the
        advertising content that you see on websites that you visit.
      </p>
      <p>
        Note that&nbsp;www.BankX.io&nbsp;has no access to or control over these
        cookies that are used by third-party advertisers.
      </p>
      <h2>Third Party Privacy Policies</h2>
      <p>
        www.BankX.io&nbsp;Privacy Policy does not apply to other advertisers or
        websites. Thus, we are advising you to consult the respective Privacy
        Policies of these third-party ad servers for more detailed information.
        It may include their practices and instructions about how to opt-out of
        certain options.
      </p>
      <p>
        You can choose to disable cookies through your individual browser
        options. To know more detailed information about cookie management with
        specific web browsers, it can be found at the browsers’ respective
        websites.
      </p>
      <h2>Children’s Information</h2>
      <p>
        Another part of our priority is adding protection for children while
        using the internet. We encourage parents and guardians to observe,
        participate in, and/or monitor and guide their online activity.
      </p>
      <p>
        www.BankX.io&nbsp;does not knowingly collect any Personal Identifiable
        Information from children under the age of 13. If you think that your
        child provided this kind of information on our website, we strongly
        encourage you to contact us immediately and we will do our best efforts
        to promptly remove such information from our records.
      </p>
      <h2>Online Privacy Policy Only</h2>
      <p>
        This Privacy Policy applies only to our online activities and is valid
        for visitors to our website with regards to the information that they
        shared and/or collect in&nbsp;www.BankX.io. This policy is not
        applicable to any information collected offline or via channels other
        than this website.
      </p>
      <h2>Consent</h2>
      <p>
        By using our website, you hereby consent to our Privacy Policy and agree
        to its Terms and Conditions.
      </p>
      <h2>Additional Items</h2>
      <p>
        You will notice the theme of the above text is that you should have
        absolutely no expectations of any sort regarding anything, and if
        anything goes wrong, you shouldn’t look for redress anywhere, and you
        should receive none. Everything is subject to change at anytime.
        Software is hard. Blockchain software is harder. Everything could go
        terribly wrong and you would be out of luck. A common mistake users make
        is to send their cryptocurrency directly to a contract address on
        Ethereum or similar smart contract enabled blockchain. Anything you
        send, you lose, and will not get back. This nearly always results in the
        total loss of their funds.
      </p>
      <p>
        During the sacrifice phase, if you send things not supported, you get no
        x-points. If you send before or after the sacrifice phase period, you
        get no x-points. If you sacrifice cryptocurrency without using the
        sacrifice application on www.BankX.io, you will get no x-points. The
        moral of the story here is, on the blockchain, it’s very easy to make
        mistakes, you must be very careful.
      </p>
      <h2>NFT Terms of Purchase and Use</h2>
      <h2>BankX NFT’s:</h2>
      <div>
        <ul>
          <li>
            may, where expressly stated, include additional functionality,
            capabilities, content, or access to private membership social media
            groups;
          </li>
          <li>may be unique or part of a limited series,</li>
          <li>
            may include the ability to mint the stablecoin at certain times and
            may increase the amount of BankX tokens you receive for locking up
            tokens in Token LockUp Rewards;
          </li>
          <li>
            may be subject to additional terms or qualifications as stated in
            the description of the NFT; and
          </li>
          <li>
            are subject to applicable laws as in effect from time to time.
          </li>
        </ul>
      </div>
      <h2>Ownership:</h2>
      <p>
        “Own” means your rights with respect to a NFT that you have purchased or
        otherwise rightfully acquired from the BankX NFT smart contract, where
        proof of such purchase is recorded on the applicable blockchain. You
        agree, in relation to any NFT that you Own, that you Own that NFT in
        accordance with any description which accompanies that NFT. An issuer of
        an NFT may, at its option, use third party platforms or wallet
        extensions (which may be owned or operated by third parties) to sell
        NFTs (“Third Party Sites”).
      </p>
      <div>
        <p>
          A NFT THAT YOU OWN WILL BE TRANSFERABLE, BUT ANY TRANSFEREE WILL BE
          SUBJECT TO THESE NFT TERMS. NFTS THAT ARE PROVIDED BY BANKX ARE FOR
          UTILITY PURPOSES TIED TO UNIQUE CAPABILITIES AND MEMBERSHIP
          EXPERIENCES. YOU SHOULD NOT PURCHASE BANKX NFT’S WITH A VIEW OF
          INVESTMENT, RESALE OR SPECULATION. THERE CAN BE NO ASSURANCE AS TO
          THEIR PRESENT OR FUTURE VALUE, TRANSFERABILITY OR MARKETABILITY. YOU
          AGREE BY PURCHASING THE NFT THAT YOU HAVE NO EXPECTATION OF PROFIT AND
          YOU ARE NOT RELYING ON THE WORK OF OTHERS OR THIRD PARTY PROMOTERS.
        </p>
        <p>
          The NFT allows you to mint stablecoin at certain times, increase the
          BankX tokens you receive for locking up tokens in Token LockUp Rewards
          and gives special access to private social media groups. It is only
          you, your NFT and the blockchain performing these functions.
        </p>
      </div>
      <h2>Risks:</h2>
      <div>
        <p>
          Once you Own any NFT, you are responsible for any damage, or loss of
          access, to the NFT. Neither BankX nor any of its affiliates, partners,
          developers, etc. shall have any liability in such circumstances,
          regardless of cause. You expressly understand and agree that your use
          of BankX and any NFTs is at your sole risk and that BankX and the NFTs
          are provided “as is” and “as available”.
        </p>
        <p>
          There are risks associated with using Internet-based digital assets
          such as NFTs and cryptocurrency, including, but not limited to, the
          risk of hardware, software and Internet connections, the risk of
          malicious software introduction, and the risk that third parties may
          obtain unauthorized access to information stored within your
          electronic wallet. You accept and acknowledge that BankX will not be
          responsible for any communication failures, disruptions, errors,
          distortions or delays you may experience when using the blockchain
          network, however caused.
        </p>
        <p>
          The regulatory and legal regime governing blockchain technologies,
          cryptocurrencies, and tokens is uncertain, and new regulations or
          policies may materially adversely affect the development of the
          Platform ecosystem, and therefore the potential utility or value of
          your NFTs. You accept and acknowledge that neither BankX, its
          contributors, affiliates, or members of its communite will not be
          responsible for the risk of changes to the regulatory and legal regime
          governing blockchain technologies, cryptocurrencies, and tokens and
          new regulations, unfavorable regulatory intervention in one or more
          jurisdictions or policies any of which may materially adversely affect
          the use and value of the NFTs.
        </p>
        <h2>Taxes:</h2>
        <p>
          You are solely responsible for determining what, if any, taxes apply
          to your NFT-related transactions. Neither BankX, its contributors,
          affiliates, or community members are not responsible for determining
          the taxes that apply to your transactions on the Platform or other
          NFT-related transactions.
        </p>
        <h2>Disclaimer of Warranty:</h2>
        <p>
          THERE IS NO WARRANTY FOR BANKX OR ANY NFT’S, TO THE EXTENT PERMITTED
          BY APPLICABLE LAW. EXCEPT WHEN OTHERWISE STATED IN WRITING, AN NFT
          ISSUER AND/OR OTHER PARTIES PROVIDE THE PLATFORM AND NFT’S “AS IS”
          WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED OR IMPLIED, INCLUDING,
          BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR
          A PARTICULAR PURPOSE OR NONINFRINGEMENT.
        </p>
        <h2>Limitation of Liability:</h2>
        <p>
          EXCEPT AS REQUIRED BY NONWAIVABLE PROVISIONS OF APPLICABLE LAW OR
          AGREED TO IN WRITING, A NFT ISSUER (OR ANY LICENSOR) SHALL NOT BE
          LIABLE TO YOU OR ANY OTHER PARTY FOR DAMAGES, INCLUDING ANY GENERAL,
          SPECIAL, INCIDENTAL, PUNITIVE OR CONSEQUENTIAL DAMAGES ARISING OUT OF
          THE USE OR INABILITY TO USE BANKX OR ANY NFT’S OR ELEMENTS THEREOF
          (INCLUDING BUT NOT LIMITED TO LOSS OF DATA OR DATA BEING RENDERED
          INACCURATE OR LOSSES SUSTAINED BY YOU OR THIRD PARTIES), EVEN IF YOU
          OR OTHER PARTY HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
        </p>
        <h2>Cryptocurrency Financial Transactions:</h2>
        <p>
          Any cryptocurrency payments or financial transactions that you engage
          in via BankX will be conducted solely through the blockchain network.
          BankX has no control over these payments or transactions, nor does
          BankX have the ability to reverse any payments or transactions. BankX
          does not provide refunds for any purchases that you might make on or
          through BankX – whether NFTs or anything else.
        </p>
        <p>
          BankX has no liability to you or to any third party for any claims or
          damages that may arise as a result of any payments or transaction that
          you engage in via BankX, or any other payment or transactions that you
          conduct via the blockchain network.
        </p>
        <h2>Entire Agreement:</h2>
        <p>
          These NFT Terms, together with the BankX Sacrifice Phase Disclaimer,
          Website Terms and Conditions of Use and Privacy Policy constitute the
          entire agreement between you and BankX with respect to the NFT’s, use
          of the BankX website and the system of blockchain contracts. The
          failure of BankX to exercise or enforce any right or provision of
          these terms shall not constitute a waiver of such right or provision.
          If any provision of these terms is found by a court of competent
          jurisdiction to be invalid, the parties nevertheless agree that the
          court should endeavor to give effect to the parties’ intentions as
          reflected in that provision, and the other provisions of these terms
          remain in full force and effect.
        </p>
      </div>
    </Tabpanel>
  </>
);

export default Terms;
